import React, { FC, useMemo, useCallback } from 'react'
import { cn } from 'shared/utils'

import { TSelectOption } from 'shared/types'
import { createCustomOption } from 'shared/utils/formatDate'
import { DateRangePicker, FilterRangeCustom } from 'modulesCommon/Filters/components'

import { FilterListProps } from './FilterList.props'

import styles from './FilterList.module.scss'

export const FilterList: FC<FilterListProps> = ({
  value,
  onSelect,
  options,
  customOption
}) => {
  const customValue = useMemo((): TSelectOption | undefined => {
    if (customOption && value?.match(/from/)) {
      return createCustomOption(value)
    }
  }, [customOption, value])

  const selectValue = useCallback((option: TSelectOption) => () => {
    onSelect(option.value)
  }, [onSelect])

  return (
    <div className={styles.list}>
      {options.map((option) => (
        <div
          className={cn(styles.listItem, {[styles.listItemChecked]: option.value === value})}
          onClick={selectValue(option)}
          key={option.value}
        >
          {option.label}{option.title ? <small> ({option.title})</small> : null}
        </div>
      ))}

      {customOption?.map(({ label, type }) => {
        if (type === 'week' || type === 'month' || type === 'range') {
          return (
            <DateRangePicker
              key={label}
              onSelect={selectValue}
              value={customValue}
              type={type}
              {...(type === 'range' && { placeholder: label})}
            />
          )
        }
        return <FilterRangeCustom key={label} />
      })}
    </div>
  )
}
